export const APP_TOKEN_ADDRESS = process.env.REACT_APP_TOKEN_ADDRESS;
export const DEFAULT_CHAIN = process.env.REACT_APP_DEFAULT_CHAIN;
export const PROVENANCE_HASH = process.env.REACT_APP_PROVENANCE_HASH;